import { render } from "./OrderEditMainInfo.vue?vue&type=template&id=0dfac1d7&scoped=true"
import script from "./OrderEditMainInfo.vue?vue&type=script&lang=js"
export * from "./OrderEditMainInfo.vue?vue&type=script&lang=js"

import "./OrderEditMainInfo.vue?vue&type=style&index=0&id=0dfac1d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfac1d7"]])

export default __exports__